import { isCapabilityEnabled } from "owa-capabilities";
import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { newHeaderCapability } from "./newHeaderCapability";

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability gates add-ins drawer pane behavior in popouts based on
 * feature flag state and new header availability.
 */
export const addinsUseDrawerPaneInpopoutsCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true;
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return (isGlobalFeatureEnabled("addin-useDrawerPaneInpopouts") &&
            isCapabilityEnabled(newHeaderCapability));
    },
};
